import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { AuthService } from '../../services';
import { LoginBanner } from "../../assets/img";
import { Input } from '../../components';

const Recover = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    }

    if (!email)
      return onError('Debe ingresar el correo electrónico');

    if (!email.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/))
      return onError('El correo electrónico no es válido');

    return true;
  }

  const submit = async (e) => {
    e.preventDefault();

    if (!isValidForm()) return;

    try {
      await AuthService.recover({ email });
      toast.success('Se le ha enviado un correo electrónico');
      navigate('/login');

    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="flex min-h-screen w-full bg-white font-sans overflow-hidden">
      <button className="absolute top-10 left-10 text-gray-500 hover:text-gray-800 transition-colors" onClick={() => navigate('/', { replace: true })}>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
        </svg>
      </button>

      <div className="flex flex-col justify-center items-center w-full lg:w-1/2 p-8 lg:p-20">
        <form className="w-full max-w-sm flex flex-col items-center" onSubmit={submit}>
          <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Recuperar contraseña
          </h1>

          <p className="text-gray-700 text-center text-lg mb-10 max-w-sm leading-tight">
            Coloque el correo electrónico que está afiliado a la cuenta y le enviaremos un código.
          </p>

          <Input
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onValueChange={setEmail}
          />

          <button className="flex justify-center gap-4 w-full bg-red text-white font-bold py-3 rounded-2xl shadow-lg transition-colors text-xl mt-10">
            <span>Enviar</span>
          </button>
        </form>
      </div>

      <div className="hidden lg:flex relative w-1/2">
        <img
          src={LoginBanner}
          className="w-full h-screen object-cover"
          alt="City background"
        />
      </div>
    </div>
  )
}

export default Recover;
